/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */

<template>
  <div :class="'lateral-menu ' + (collapsedMenu ? 'menu-overlay-active ' : '')"
    @click="collapsedMenu && collapseMenu()">
  </div>

  <aside class="sidebar" :class="collapsedMenu ? 'active' : ''">
    <div class="container-menu" :class="collapsedMenu ? 'active' : ''">
      <div class="scrollable-modules">
        <div class="module-list">

          <router-link v-for="opcion in menuPrincipal" :key="opcion.ruta" :to="opcion.ruta" class="menu-item"
            active-class="active" :title="opcion.nombre" :id="opcion.nombre.toLowerCase().includes('cotizaciones') ? 'tour-cotizaciones' :
              (opcion.nombre.toLowerCase().includes('clientes') ? 'tour-clientes' : null)">
            <i :class="['fa-solid', opcion.icono]"></i>
            <span v-if="collapsedMenu">{{ opcion.nombre }}</span>
          </router-link>

        </div>
      </div>

      <div class="fixed-bottom">

        <router-link v-for="opcion in menuConfiguracion" :key="opcion.ruta" :to="opcion.ruta" class="menu-item"
          active-class="active" :title="opcion.nombre">
          <i :class="['fa-solid', opcion.icono]"></i>
          <span v-if="collapsedMenu">{{ opcion.nombre }}</span>
        </router-link>

        <a class="cerrar-sesion" @click="cerrarSesion">
          <i class="fas fa-right-from-bracket" style="transform: scaleX(-1);"></i>
          <div class="cerrar-txt" :class="!collapsedMenu ? 'off' : ''" v-if="collapsedMenu">Cerrar sesión</div>
        </a>

        <div id="tour-toggle-btn" class="collapse-menu-lateral desktop-only-button" @click="collapseMenu">
          <img class="chevron" src="../assets/svg/chevron.svg" alt="icon"
            :style="{ transform: collapsedMenu ? 'rotate(0deg)' : 'rotate(180deg)' }" />
        </div>
      </div>
    </div>
  </aside>

</template>

<script>
import { getMenuPorRol } from '@/utils/permisos.js';
import AuthService from '@/services/authService';


export default {
  name: 'MenuLateral',
  data() {
    return {
      mobileBreakpoint: 810,
    };
  },
  computed: {
    collapsedMenu() {
      return this.$store.state.collapsedMenu;
    },
    isMobile() {
      if (typeof window !== 'undefined') {
        return window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`).matches;
      }
      return false;
    },
    usuarioRolId() {
      if (typeof window === 'undefined') return null;

      const userDataString = localStorage.getItem('userData');
      if (!userDataString) return null;

      try {
        const userData = JSON.parse(userDataString);
        const rawRolId = userData.rol ? userData.rol.id_rol : userData.id_rol;
        const rolId = parseInt(rawRolId);

        return isNaN(rolId) ? null : rolId;

      } catch (e) {
        console.error("Error al obtener rol del userData:", e);
        return null;
      }
    },
    menuFiltradoCompleto() {
      return getMenuPorRol(this.usuarioRolId);
    },
    menuPrincipal() {
      const rutasExcluidas = ['/Configuraciones', '/Kiosko'];
      return this.menuFiltradoCompleto.filter(opcion => !rutasExcluidas.includes(opcion.ruta));
    },
    menuConfiguracion() {
      const rutasIncluidas = ['/Configuraciones', '/Kiosko'];
      return this.menuFiltradoCompleto.filter(opcion => rutasIncluidas.includes(opcion.ruta));
    }
  },

  watch: {
    collapsedMenu(newVal) {
      if (typeof window !== 'undefined' && this.isMobile) {
        if (newVal) {
          document.body.classList.add('menu-abierto');
        } else {
          document.body.classList.remove('menu-abierto');
        }
      }
    },
  },
  beforeUnmount() {
    if (typeof window !== 'undefined') {
      document.body.classList.remove('menu-abierto');
    }
  },
  methods: {
    collapseMenu() {
      this.$store.commit('toggleMenu');
    },
    async cerrarSesion() {
      try {
        await AuthService.logout();
      } catch (error) {
        console.error("Error al cerrar sesión en el servidor", error);
      } finally {
        localStorage.removeItem('userData');
        localStorage.removeItem('usuario');
        localStorage.removeItem('rolUsuario');
        localStorage.removeItem('nombreUsuario');
        this.$router.push('/');
      }
    },
  },
};
</script>

<style scoped>
body.menu-abierto {
  overflow: hidden;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
}

.lateral-menu {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: transparent;
  z-index: 1040;
  pointer-events: none;
  transition: background-color 0.3s ease;
}

@media (max-width: 810px) {
  .lateral-menu.menu-overlay-active {
    background-color: rgba(0, 0, 0, 0.3);
    pointer-events: auto;
  }
}

.sidebar {
  position: fixed;
  display: flex;
  flex-direction: column;
  top: 85px;
  bottom: 0;
  left: 0;
  z-index: 1050;
  width: 90px;
  transition: width 0.3s, transform 0.3s;
}

.sidebar.active {
  width: 215px;
}

.container-menu {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #ffffff;
  box-shadow: 0px 3px 6px #00000029;
  transition: width 0.3s;
  min-width: 90px;
  max-width: 215px;
  width: 90px;
  height: 100%;
  overflow: hidden;
}

.container-menu.active {
  width: 215px;
}

.scrollable-modules {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.scrollable-modules::-webkit-scrollbar {
  display: none;
}

.fixed-bottom {
  flex-shrink: 0;
}

.module-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.menu-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
  font-size: 13px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  width: 100%;
  text-decoration: none;
}

.menu-item i {
  font-size: 30px;
  color: #333;
}

.menu-item span {
  font-size: 15px;
  opacity: 1;
  transition: opacity 0.2s;
  margin-left: 30px;
  white-space: nowrap;
  width: 60px;
  text-align: left;
  margin-right: 35px;
}

.sidebar:not(.active) .menu-item span {
  opacity: 0;
  width: 0;
  overflow: hidden;
}

.menu-item.active {
  background-color: #d2d2d2;
}

.cerrar-sesion {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  width: 100%;
  text-decoration: none;
  color: #af0000c4;
}

.cerrar-sesion:active {
  background-color: #d2d2d2;
}

.cerrar-txt {
  transition: all 0.4s;
  font-size: 14px;
  font-family: Roboto, sans-serif;
  display: flex;
  align-items: center;
  opacity: 1;
  overflow: hidden;
  white-space: nowrap;
  font-weight: bold;
  color: #af0000c4;
  margin-left: 15px;
}

.cerrar-txt.off {
  opacity: 0;
}

.collapse-menu-lateral {
  position: absolute;
  top: 50%;
  right: -14px;
  transform: translateY(-50%);
  padding: 8px 4px;
  cursor: pointer;
  z-index: 10;
  border-radius: 50%;
  background-color: #2a428c;
  width: 20px;
  height: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.15s all ease-in-out;
}

.collapse-menu-lateral-fixed {
  position: fixed;
  top: 50%;
  left: 0;
  transform: translateY(-50%) translateX(0);
  z-index: 1060;
  background-color: #29b9f6;
  padding: 10px;
  cursor: pointer;
  border-radius: 0 50% 50% 0;
  width: 25px;
  height: 25px;
  display: none;
  justify-content: center;
  align-items: center;
  transition: transform 0.3s ease-in-out;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.2);
}

.chevron {
  transition: transform 0.3s ease-in-out;
  width: 15px;
  height: 15px;
}

.cerrarMenuMovil {
  display: none;
}

@media (max-width: 810px) {

  .collapse-menu-lateral {
    display: none;
  }
  .sidebar.active {
    height: calc(100vh - 85px);
    position: fixed;
    top: 85px;
    bottom: unset;
  }

  .sidebar {
    width: 215px;
    top: 85px;
    position: fixed;
    bottom: 0;
    height: auto;

    transform: translateX(-215px);
    transition: transform 0.3s ease-in-out;
  }

  .sidebar.active {
    width: 215px;
    transform: translateX(0);
    box-shadow: 3px 0 6px rgba(0, 0, 0, 0.3);
  }

  .container-menu,
  .container-menu.active {
    width: 215px;
    max-width: unset;
    height: 100%;
    overflow: hidden;
  }

  .collapse-menu-lateral-fixed {
    display: flex;
    z-index: 1060;
  }

  .collapse-menu-lateral-fixed.is-active {
    left: 0;
    transform: translateY(-50%) translateX(190px);
    border-radius: 50%;
  }

  .menu-item {
    padding-left: 40px;
    justify-content: flex-start;
  }

  .menu-item i {
    font-size: 22px;
    margin-right: 15px;
  }

  .menu-item span {
    font-size: 14px;
    margin-left: 0;
    width: auto;
    opacity: 1;
    overflow: visible;
  }

  .cerrar-sesion {
    justify-content: flex-start;
    padding: 15px 40px;
  }

  .cerrar-sesion i {
    font-size: 22px;
    margin-right: 15px;
  }

  .cerrar-txt {
    opacity: 1;
    margin-left: 0;
    font-size: 14px;
    width: auto;
  }

  .cerrar-txt.off {
    opacity: 1;
  }
}

@media (min-width: 811px) {
  .collapse-menu-lateral-fixed {
    display: none;
  }
}
</style>